import { PalmettoLogo } from '@palmetto/dsm-components';
import { useUser } from '../../api/user/useUser';
import { useCurrentRouteStaticData } from '../_app/Routes/useCurrentRouteStaticData';
import React, { useContext } from 'react';
import { currentPageContext } from '../_app/CurrentPageProvider/currentPageContext';
import { useTranslation } from '@helios/frontend-core';
import ImpersonationBanner from './components/ImpersonationBanner/ImpersonationBanner';

export interface HeaderProps {
  forceImpersonationBanner?: boolean;
}

const Header: React.FC<HeaderProps> = (props: HeaderProps) => {
  const { forceImpersonationBanner = false } = props;
  const { t } = useTranslation();
  const { isAuthenticated } = useUser();
  const { pageTitle: currentPageTitle, leftContent, rightContent } = useContext(currentPageContext);
  const currentRouteStaticData = useCurrentRouteStaticData();

  const pageTitle = currentPageTitle || currentRouteStaticData?.headerProps?.pageTitle;
  const hideHeader = currentRouteStaticData?.headerProps?.hideHeader || !isAuthenticated;

  if (hideHeader) {
    return null;
  }

  return (
    <>
      <ImpersonationBanner forceImpersonationBanner={forceImpersonationBanner} />
      {/* Desktop Header */}
      <header className="min-h-24 hidden lg:block">{/* TODO: Should have breadcrumbs on non root pages */}</header>

      {/* Mobile Header */}
      <header className="min-h-[var(--app-header-height)] box-content grid grid-cols-[1fr_auto_1fr] items-center mx-8 lg:hidden">
        <div className="flex justify-start">{leftContent}</div>
        <div className="flex justify-center">
          {pageTitle ? (
            <h1 className="label-400 md:label-600 text-text-primary mx-8">{t(pageTitle)}</h1>
          ) : (
            <PalmettoLogo variant="wordmark" className="w-[125px]" tabIndex={-1} />
          )}
        </div>
        <div className="flex justify-end">{rightContent}</div>
      </header>
    </>
  );
};

export default Header;
